import React from "react";
import { motion } from "framer-motion";
import { Applications } from "../Data";

const Application = () => {

  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.2,
      },
    },
  };

  const fade = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const cardAnim = {
    hidden: { opacity: 0, scale: 0.98 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.4,
        ease: "easeOut",
      },
    },
  };


  return (
    <section className="application-section">
      <div className="container">

        {/* TEXT */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.h3 className="section-subheading" variants={fade}>
            Perfect for every space
          </motion.h3>

          <motion.h2 className="section-heading" variants={fade}>
            Built for Every Tiling Application
          </motion.h2>

          <motion.p className="section-text" variants={fade}>
       Suitable for all tiling needs, from interior spaces to demanding exterior and high-performance applications, ensuring reliable results across every project.
          </motion.p>
        </motion.div>

        {/* GRID */}
        <motion.div
          className="application-grid"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {Applications.map((item, i) => (
            <motion.div
  className="application-card"
  key={i}
  variants={cardAnim}
  whileHover={{
    scale: 1.05,
    y: -8,
    boxShadow: "0 20px 40px rgba(0,0,0,0.15)"
  }}
  transition={{ duration: 0.3, ease: "easeOut" }}
>
  {/* IMAGE WRAPPER (important for zoom crop) */}
  <div className="application-img-wrapper">
    <motion.img
      src={item.img}
      alt={`${item.title} | VigoFlex`}
      className="application-img"
      whileHover={{ scale: 1.15 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    />
  </div>

  <div className="application-content">
    <h4 className="card-heading">{item.title}</h4>
  </div>
</motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default Application;